import React from 'react';
import { Page } from 'components';
import ReferenceDataProvider from './ReferenceDataContext';
import ReferenceData from './ReferenceData';


let Index = () => {
    return (
        <ReferenceDataProvider>
            <Page title="Reference data">
                <ReferenceData />
            </Page>
        </ReferenceDataProvider>
    );
}

export default Index;